import { Link } from "react-router-dom";
import { site } from "@/mocks/site";

export default function CtaBand() {
  return (
    <section className="w-full px-4 py-14 md:px-8 md:py-20">
      <div className="relative w-full overflow-hidden rounded-card">
        <div className="relative w-full" style={{ aspectRatio: "21 / 8", minHeight: "220px" }}>
          <img
            src="https://readdy.ai/api/search-image?query=warm%20abstract%20gradient%20of%20crimson%20and%20amber%20stage%20light%20beams%20with%20soft%20bokeh%2C%20dark%20moody%20cinematic%20background%2C%20no%20text&width=1600&height=620&seq=cta-hl-01&orientation=landscape"
            alt="暖色舞台灯光抽象背景，引导推荐话题"
            title="黑料在线 · 推荐话题"
            className="h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/60 to-foreground-950/40" />
          <div className="absolute inset-0 flex flex-col justify-center px-6 md:px-12">
            <span className="text-xs font-label tracking-widest text-accent-300">SUBMIT A TOPIC</span>
            <h2 className="mt-3 max-w-xl font-heading text-xl font-bold leading-snug text-background-50 md:text-3xl">
              发现了值得一聊的话题？告诉我们
            </h2>
            <p className="mt-3 hidden max-w-xl text-sm leading-relaxed text-background-200 sm:block">
              留下话题名称与公开来源，编辑会在 2 个工作日内回复是否适合做成速览。我们只做公开讨论的二次归纳。
            </p>
            <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center">
              <Link
                to="/contact"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-label text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
              >
                <i className="ri-send-plane-line" />
                推荐一个话题
              </Link>
              <Link
                to="/about"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-5 py-3 text-sm font-label text-background-50 transition-colors hover:bg-background-50/10 cursor-pointer"
              >
                了解网站定位
              </Link>
            </div>
          </div>
        </div>
      </div>
      <p className="mt-4 text-center text-xs text-foreground-500">
        联系邮箱：{site.email} · 工作时间：{site.workingHours}
      </p>
    </section>
  );
}